import { format } from 'date-fns/format'
import Countdown from 'react-countdown'

import arrowIcon from '@/assets/icons/black-friday/arrow.png'
import discountIcon from '@/assets/icons/black-friday/discount.png'
import { Tooltip } from '@/components/ui/tooltip'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'

import { BLACK_FRIDAY_CAMPAIGN_END } from '../consts'

export const BlackFridayPromotion = () => {
  const handleOpenDialog = () =>
    openDialog({
      type: DIALOG_TYPE.BLACK_FRIDAY_PROMOTION,
    })

  return (
    <div className="bg-black p-0.5 flex items-center gap-[14px] rounded-full">
      <button
        onClick={handleOpenDialog}
        className="group relative pl-4 flex gap-2 overflow-hidden items-center h-9 rounded-full border-[1.5px] border-[#0057FF] transition-shadow hover:shadow-[0_0_8px_4px_rgba(0,87,255,0.40)_inset,0_5px_11px_0_rgba(215,58,73,0.02)]"
      >
        <img
          src={arrowIcon}
          alt="Arrow"
          className="absolute left-4 h-6 top-1/2 -translate-y-1/2 -translate-x-14 group-hover:translate-x-0 transition-transform duration-500"
        />
        <span className="group-hover:translate-x-12 transition-transform duration-500 text-base text-nowrap text-ellipsis sm:text-lg leading-6 text-white">
          Black Friday Deal
        </span>
        <img
          src={discountIcon}
          alt="Discount"
          className="group-hover:translate-x-14 transition-transform duration-500 h-7"
        />
      </button>
      <Tooltip
        className="max-sm:hidden"
        content={`Ends ${format(BLACK_FRIDAY_CAMPAIGN_END, 'MMM d')}`}
      >
        <p className="text-white text-[17px] font-medium pr-3">
          <Countdown
            intervalDelay={1000}
            autoStart
            date={BLACK_FRIDAY_CAMPAIGN_END}
            renderer={({ days, hours, minutes, seconds }) =>
              [...(days > 0 ? [days] : []), hours, minutes, seconds]
                .map((item) => String(item).padStart(2, '0'))
                .join(' : ')
            }
          />
        </p>
      </Tooltip>
    </div>
  )
}
